import script from "./PopperActionLiveChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopperActionLiveChat.vue?vue&type=script&setup=true&lang=ts"

import "./PopperActionLiveChat.vue?vue&type=style&index=0&id=660aeb42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-660aeb42"]])

export default __exports__